import React from 'react'
import DentalHeader from '../Components/DentalHeader'
import DentalFooter from '../Components/DentalFooter'

const DrNVNikhitha = () => {
    return (
        <>
            <DentalHeader />
            <div className='topmargin'></div>
            <div className="container-fluid strips " id="strip" style={{ marginTop: '100px', display: 'flex', backgroundColor: "#d4296b", }}>
                <div className="col text-center strip1" style={{ color: 'white' }}>
                    <div className="row mt-5" >
                        <h3 className='mt-2 mb-2' style={{ textTransform: 'uppercase' }}>Dr.N V Nikhitha</h3>
                    </div>
                    <ul className="container mb-5" style={{ listStyle: 'none', textAlign: 'center' }}>
                        <li ><a href="/Dental_Care_Home" style={{ color: 'white' }}>Home</a></li>
                    </ul>
                </div>
            </div>

            <div className='container mt-5'>
                <div className='row'>
                    <div className='col-md-7 col-sm-12'>
                        <p>Dr. NV Nikhitha, BDS, FAAD, is a Root Canal Specialist with qualifications that include a Bachelor of Dental Surgery (BDS) and a Fellowship in Aesthetic and Advanced Dentistry (FAAD). Her expertise lies in diagnosing and treating dental pulp issues, with a focus on root canal procedures.</p>
                    </div>
                    <div className='col-md-5 col-sm-12 services mb-2'>
                        <img src='Nikitha.jpg' alt='' style={{ width: '90%' }}></img>
                    </div>
                </div>
            </div>

            <DentalFooter />
        </>
    )
}

export default DrNVNikhitha